<template lang="pug">
  div.full-width.mt-n12
    div.d-flex.flex-grow
      v-row.header-filter
        v-col(sm=3)
          div.media-date-picker.mt-4
            DateRangePicker(
              :placeholder="$t('table.log.date')",
              :value.sync="dates",
              @update:value="fetch",
            )
        v-col(sm=3)
          v-select(
            clearable,
            required,
            hide-details,
            v-model="shop_id",
            item-text="name",
            item-value="id",
            :items="shops"
            :label="$t('table.log.shop')",
            @input="fetch",
          )
            template(v-slot:selection="{ item }")
              div {{ item.name }}
        v-col(fluid)
          v-spacer
        v-col(sm=2)
          LimitPicker(
            :value.sync="limit",
            @update:value="fetch",
          )
    v-card.mt-2.full-width(width="100")
      LogTable(
        ref="LogTable",
        :dates="dates",
        :limit="limit",
        :shopId="shop_id",
      )

</template>

<script>
import { mapGetters } from 'vuex';
import { progressWrapper, roleManager } from '@/config/mixins.js';
import { subDurationFromToday } from '@/utils/time';

import DateRangePicker from '@/components/forms/inputs/DateRangePicker.vue';
import LimitPicker from '@/components/table/LimitPicker.vue';
import LogTable from '@/components/table/LogTable.vue';

export default {
  components: {
    DateRangePicker,
    LimitPicker,
    LogTable,
  },

  mixins: [progressWrapper, roleManager],
  data: () => ({
    limit: 10,
    dates: [subDurationFromToday({ days: 10 }), new Date()],
    shop_id: null,
  }),

  computed: {
    ...mapGetters({
      shops: 'shop/items',
    }),
  },

  created() {
    this.wrapProgress(() => {
      this.$store.dispatch('shop/fetch', {});
    });
  },

  methods: {
    fetch() {
      this.$nextTick(() => {
        this.$refs.LogTable.fetch(true);
      });
    },
  },
};
</script>
